module.exports = __webpack_public_path__ + "10328351a20a05d816547727ada38b70.svg";